module.exports = __webpack_public_path__ + "static/media/RP-41.0cc673f6.pdf";